import locationData from '../../../data/autocomplete_location_data';
import { updateMapView } from '../location';
import {
  updateListWithProxymityFilter,
  getCoordinatesFromAddress
} from '../location/locationUtils';

// Format the data for autocomplete
const formattedLocations = locationData.map(location => ({
  label: `${
    location.Suburb.charAt(0).toUpperCase() +
    location.Suburb.slice(1).toLowerCase()
  } ${location.Zip}`,
  value: `${
    location.Suburb.charAt(0).toUpperCase() +
    location.Suburb.slice(1).toLowerCase()
  } ${location.Zip}`
}));

/**
 * Updates the list and map based on the provided latitude and longitude.
 *
 * This function focuses on the given location, filters map markers within a certain radius,
 * updates the list with proximity filter, and sets the map view to the user location.
 *
 * @param {number} latitude - The latitude of the user's location.
 * @param {number} longitude - The longitude of the user's location.
 */

export async function handleSubmitSearch(context, inputValue) {
  if (inputValue) {
    const location = await getCoordinatesFromAddress(inputValue);
    // You can also trigger additional logic here, like updating the UI
    updateListWithProxymityFilter(location.latitude, location.longitude);
    updateLocationData(context, location.latitude, location.longitude);
  } else {
    updateListWithProxymityFilter();
    updateLocationData(context);
  }
}

export function updateLocationData(context, latitude, longitude) {
  const mapViewContainer = context.getElementById('map-view-container');
  mapViewContainer.setAttribute('data-location-latitude', latitude);
  mapViewContainer.setAttribute('data-location-longitude', longitude);
}
function autocomplete(context, inp, arr) {
  if (context && inp) {
    const clearButton = context.getElementById('autocomplete-clear-button');
    /*the autocomplete function takes two arguments,
  the text field element and an array of possible autocompleted values:*/
    var currentFocus;
    /*execute a function when someone writes in the text field:*/
    inp.addEventListener('input', function (e) {
      context.getElementById('map-status-filter').dataset.show = 'false';
      var a,
        b,
        i,
        val = this.value;
      /*close any already open lists of autocompleted values*/
      closeAllLists();
      if (!val) {
        return false;
      }
      currentFocus = -1;
      /*create a DIV element that will contain the items (values):*/
      a = context.createElement('DIV');
      a.setAttribute('id', this.id + 'autocomplete-list');
      a.setAttribute('class', 'autocomplete-items');
      /*append the DIV element as a child of the autocomplete container:*/
      context.getElementById('autocomplete-result-box').appendChild(a);
      /*for each item in the array...*/
      for (i = 0; i < arr.length; i++) {
        const label = arr[i].label;
        const value = arr[i].value;
        /*check if the item starts with the same letters as the text field value:*/
        if (label.toUpperCase().includes(val.toUpperCase())) {
          /* Create a DIV element for each matching element */
          b = context.createElement('DIV');

          /* Find the position of the match */
          const startIndex = label.toUpperCase().indexOf(val.toUpperCase());

          /* Highlight the matching part */
          b.innerHTML =
            '<span>' +
            label.substring(0, startIndex) + // Part before the match
            '<strong>' +
            label.substring(startIndex, startIndex + val.length) +
            '</strong>' + // The matching part
            label.substring(startIndex + val.length) +
            '</span>' +
            '<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none"><path d="M11.4531 22.12L17.5598 16L11.4531 9.88L13.3331 8L21.3331 16L13.3331 24L11.4531 22.12Z" fill="#4F6970"/></svg>'; // Part after the match

          /* Insert an input field that will hold the current array item's value */
          b.innerHTML += "<input type='hidden' value='" + value + "'>";

          /* Execute a function when someone clicks on the item value (DIV element) */
          b.addEventListener('click', function (e) {
            /* Insert the value for the autocomplete text field */
            inp.value = this.getElementsByTagName('input')[0].value;

            // Handle Select Item
            handleSubmitSearch(context, inp.value);

            clearButton.classList.remove('hidden');

            /* Close the list of autocompleted values (or any other open lists) */
            closeAllLists();
          });

          a.appendChild(b);
        }
      }
    });

    /*execute a function presses a key on the keyboard:*/
    inp.addEventListener('keydown', function (e) {
      var x = context.getElementById(this.id + 'autocomplete-list');
      if (x) x = x.getElementsByTagName('div');
      if (e.keyCode == 40) {
        /*If the arrow DOWN key is pressed,
          increase the currentFocus variable:*/
        currentFocus++;
        /*and and make the current item more visible:*/
        addActive(x);
      } else if (e.keyCode == 38) {
        //up
        /*If the arrow UP key is pressed,
          decrease the currentFocus variable:*/
        currentFocus--;
        /*and and make the current item more visible:*/
        addActive(x);
      } else if (e.keyCode == 13) {
        /*If the ENTER key is pressed, prevent the form from being submitted,*/
        e.preventDefault();
        if (currentFocus > -1) {
          /*and simulate a click on the "active" item:*/
          if (x) x[currentFocus].click();
        }
      }
    });

    if (clearButton) {
      clearButton.addEventListener('click', function (e) {
        inp.value = '';
        handleSubmitSearch(context, '');
      });
    }

    function addActive(x) {
      /*a function to classify an item as "active":*/
      if (!x) return false;
      /*start by removing the "active" class on all items:*/
      removeActive(x);
      if (currentFocus >= x.length) currentFocus = 0;
      if (currentFocus < 0) currentFocus = x.length - 1;
      /*add class "autocomplete-active":*/
      x[currentFocus].classList.add('autocomplete-active');
    }
    function removeActive(x) {
      /*a function to remove the "active" class from all autocomplete items:*/
      for (var i = 0; i < x.length; i++) {
        x[i].classList.remove('autocomplete-active');
      }
    }
    function closeAllLists(elmnt) {
      /*close all autocomplete lists in the document,
    except the one passed as an argument:*/
      var x = context.getElementsByClassName('autocomplete-items');
      for (var i = 0; i < x.length; i++) {
        if (elmnt != x[i] && elmnt != inp) {
          x[i].parentNode.removeChild(x[i]);
        }
      }
    }

    /*execute a function when someone clicks in the document:*/
    context.addEventListener('click', function (e) {
      closeAllLists(e.target);
    });
  }
}

/**
 * Configures location-based features and map interactions.
 * Sets up geolocation functionality for location buttons and handles map feature filtering based on location.
 *
 * @param {Object} context - The DOM context in which to search for elements
 * @param {Object} drupalSettings - Drupal settings object containing configuration
 * @throws {Error} Will throw an error if geolocation is not supported by the browser
 *
 * @example
 * mapAutocompleteInput(document, drupalSettings);
 */
export function mapAutocompleteInput(context, drupalSettings, once) {
  const inp = once(
    'map-autocomplete-input',
    '#map-autocomplete-input',
    context
  )[0];

  autocomplete(context, inp, formattedLocations);
}
